/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const KitchenImagesModal = ({ data, show, handleUpdateKitchen, handleDismiss }) => {
  const [kitchenImages, setKitchenImages] = useState(data.kitchenImages || []);
  const [dragOver, setDragOver] = useState(false);
  const MAX_IMAGES = 6;

  const handleImageChange = (e) => {
  
    const files = Array.from(e.target.files).slice(0, MAX_IMAGES - kitchenImages.length);
  
    if (files.length === 0) {
      console.error("No valid files received");
      return;
    }
  
    let validImages = [];
  
    files.forEach((file) => {      
      const processedFile = file; 
      
      if (!(processedFile instanceof Blob)) {
        console.error("Invalid file format:", processedFile);
        alert("Invalid file format. Please upload a valid image.");
        return;
      }
  
      const reader = new FileReader();
      reader.onloadend = () => {
        validImages.push(reader.result);
        if (validImages.length === files.length) {
          setKitchenImages((prev) => [...prev, ...validImages].slice(0, MAX_IMAGES));
        }
      };
      reader.readAsDataURL(processedFile);
    });
  };
  
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files).slice(0, MAX_IMAGES - kitchenImages.length);
    handleImageChange({ target: { files } });
  };

  const handleRemoveImage = (index) => {
    setKitchenImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClickUpload = () => {
    document.getElementById("fileInput").click();
  };

  const handleClose = () => {
    handleDismiss();
  };

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Upload Kitchen Images</Modal.Title>
        <span onClick={handleClose}>&#10006;</span>
      </Modal.Header>
      <Modal.Body>
        <div className="custom-file-upload">
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageChange}
            className="form-control"
            id="fileInput"
            hidden
          />
          <div
            className={`dropzone ${dragOver ? "dragover" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={handleClickUpload}
          >
            <p>Drag & Drop or Click to Upload</p>
            <small>Max 6 images, PNG format, size &lt; 250kB each</small>
          </div>

          {/* Image Preview Grid */}
          <div className="image-preview-grid">
            {Array.from({ length: MAX_IMAGES }).map((_, i) => (
              <div key={i} className="image-preview-slot">
                {kitchenImages[i] ? (
                  <>
                    <img src={kitchenImages[i]} alt={`Kitchen ${i + 1}`} className="img-fluid" />
                    <button className="remove-btn" onClick={() => handleRemoveImage(i)}>
                      &times;
                    </button>
                  </>
                ) : (
                  <div className="empty-slot">+</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {kitchenImages.length > 0 && (
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleUpdateKitchen(kitchenImages)}
            >
              Update
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>
              Close
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default KitchenImagesModal;
